<template>
  <div class="headerImage"
    :class="{ 'headerImage--absolute': !isHigher }">
    <PixiImage
      v-check-height
      :image="image"
      :filter="filter"
      :canAnimate="canAnimate"
      :sizes="sizes"
    />
  </div>
</template>

<script>
import PixiImage from '@/components/PixiImage/PixiImage.vue'

export default {
  name: 'HeaderImage',
  components: {
    PixiImage
  },
  data: () => ({
    isHigher: true,
    canAnimate: false
  }),
  props: {
    image: {
      required: true
    },
    filter: {
      required: true
    },
    sizes: {
      type: Array
    }
  },
  mounted () {
    this.canAnimate = true
  },
  methods: {
    checkHeight (height, vieportHeight) {
      this.isHigher = height > vieportHeight
    }
  },
  directives: {
    'check-height': {
      bind (el, binding, vnode) {
        window.addEventListener('resize', () => {
          vnode.context.checkHeight(el.getBoundingClientRect().height, window.innerHeight)
        })
      },
      update (el, binding, vnode) {
        vnode.context.checkHeight(el.getBoundingClientRect().height, window.innerHeight)
      }
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>
